<script lang="ts">
  import {onMount} from "svelte";
  import {translate} from "lib";
  import {ButtonComponent, InputField} from "ui";

  let data: any;
  let dialogType = data.name ? translate("EDIT") : translate("CREATE");
  let name: string;
  let date: string;

  const onSubmit = (): void => {
    // Build the submit data object
    const submitData: any = {};
    
    // Only include fields that have values
    if (name) submitData.name = name;
    if (date) {
      // Keep date in YYYY-MM-DD format as backend expects
      submitData.finishedAt = date;
    }
    
    data.executeFunction(submitData);
  };

  onMount((): void => {
    if (data.name) { name = data.name; }
    if (data.finishedAt) { 
      // Convert ISO date string to YYYY-MM-DD format for input[type="date"]
      date = data.finishedAt.split('T')[0];
    }
  });

  export {data};
</script>

<div class="p-4 flex flex-col gap-4">
  <div class="text-center font-semibold">
    {dialogType} {translate("WORKOUT").toLowerCase()}
  </div>

  <form class="flex flex-col gap-4" on:submit|preventDefault={onSubmit}>
    <InputField
      label={translate("TITLE")}
      placeholder={translate("LEGS_WORKOUT")}
      bind:value={name}
    />

    <InputField
      type="date"
      label={translate("DATE")}
      bind:value={date}
    />

    <div class="flex justify-center">
      <ButtonComponent type="submit">{dialogType}</ButtonComponent>
    </div>
  </form>
</div>
